import React from "react";
import { useSelector } from "react-redux";
import { keepConflictPreview, revertConflictSnapshot } from "../Common/ConflictSnapshot";

// App-wide banner shown while the user is browsing the server's latest
// guide after choosing "View Latest Version" on a save conflict — mounted
// once near the app root (see App.js) rather than inside HomeHeader.js, so
// it stays visible across Map/Places/Schedule, the same reason as mobile's
// identical ConflictPreviewBanner.js (mirrors that component's design).
// Deliberately only two actions, no dismiss-and-ignore — "Keep this
// version" / "Revert to my copy" are the only two ways out.
//
// position:"fixed" — App.js's plain desktop-grid branch (no MobileMode, no
// MapFullScreen) lays its children out with CSS Grid and explicit
// grid-template-areas (App.css's .app-grid-no-map/.app-grid-no-side); this
// component isn't one of those named areas, so without fixed positioning it
// fell into the grid's own auto-placement algorithm and rendered as a
// cramped, misplaced sliver in a leftover implicit cell instead of a full-
// width top banner (confirmed via screenshot 2026-10-03). Fixed positioning
// takes it completely out of any surrounding layout's flow — grid, flex, or
// otherwise — so it renders identically across all of App.js's render
// branches. Matches InstallPrompt.js's actual position:"fixed" pattern
// (an earlier comment here claimed to already match it without doing so).
//
// Fixed positioning overlays rather than pushes content down, so it was
// covering the real top nav bar underneath it (confirmed via a follow-up
// screenshot). App.js reserves CONFLICT_BANNER_HEIGHT of top padding on its
// own root containers whenever this is showing, rather than this component
// trying to shove the rest of the page down itself — exported here so both
// files share one height value instead of two independently-guessed numbers
// drifting apart.
export const CONFLICT_BANNER_HEIGHT = 32;

export default function ConflictPreviewBanner() {
  const previewing = useSelector((state) => state.PreviewingConflictSnapshot);

  if (!previewing) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: CONFLICT_BANNER_HEIGHT,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 12,
        padding: "0 16px",
        background: "#3598DB",
        color: "#fff",
        boxSizing: "border-box",
      }}
    >
      <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>Viewing the latest version</span>
      <button
        onClick={keepConflictPreview}
        style={{
          background: "none",
          border: "none",
          color: "#fff",
          fontSize: "0.85rem",
          fontWeight: 700,
          textDecoration: "underline",
          cursor: "pointer",
          padding: 0,
        }}
      >
        Keep this version
      </button>
      <button
        onClick={revertConflictSnapshot}
        style={{
          background: "none",
          border: "none",
          color: "#fff",
          fontSize: "0.85rem",
          fontWeight: 700,
          textDecoration: "underline",
          cursor: "pointer",
          padding: 0,
        }}
      >
        Revert to my copy
      </button>
    </div>
  );
}
